import { request } from './_core'

// ── Uploads ──────────────────────────────────────────────────

export interface PresignResult {
  uploadUrl: string
  publicUrl: string
  key:       string
}

export const uploads = {
  presign: (filename: string, contentType: string, themeSlug: string) =>
    request<PresignResult>('/uploads/presign', {
      method: 'POST',
      body:   JSON.stringify({ filename, contentType, themeSlug }),
    }),

  // Upload a file directly to S3 using a pre-signed PUT URL.
  // This bypasses the API — the request goes straight to the storage service.
  putFile: async (uploadUrl: string, file: File): Promise<void> => {
    const res = await fetch(uploadUrl, {
      method:  'PUT',
      headers: { 'Content-Type': file.type },
      body:    file,
    })
    if (!res.ok) throw new Error(`S3 upload failed: ${res.status} ${res.statusText}`)
  },
}
